import { Link } from "react-router-dom";
import { TESTIMONIALS } from "../../mocks/businessData";
import { useInView } from "../../hooks/useInView";

export default function Testimonials() {
  const { ref, inView } = useInView(0.08);

  return (
    <section ref={ref} className="bg-cream-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-16">

        {/* Header */}
        <div className={`flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6 reveal ${inView ? "visible" : ""}`}>
          <div>
            <span className="font-sans text-xs font-semibold tracking-[0.22em] uppercase text-rust-600 mb-3 block">
              Client Stories
            </span>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal leading-tight">
              What Our Clients Say
            </h2>
          </div>
          <div className="flex flex-shrink-0 items-center gap-3">
            <div className="flex items-center gap-2 bg-white border border-stone-200 rounded-full px-4 py-2">
              <i className="ri-chat-quote-fill text-rust-600 text-sm"></i>
              <span className="font-sans text-xs font-medium text-charcoal">Verified Client Reviews</span>
            </div>
          </div>
        </div>

        {/* Three cards in a grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={t.id}
              className={`bg-white rounded-xl p-7 md:p-8 flex flex-col border border-stone-100 reveal ${inView ? "visible" : ""} reveal-delay-${i + 1} ${
                i === 1 ? "md:-translate-y-3 md:border-rust-200 relative" : ""
              }`}
            >
              {/* Featured badge for center card */}
              {i === 1 && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-rust-700 text-white font-sans text-[10px] font-bold tracking-widest uppercase px-3 py-1 rounded-full whitespace-nowrap">
                  Featured
                </div>
              )}

              {/* Stars */}
              <div className="flex gap-0.5 mb-5">
                {Array.from({ length: t.rating }).map((_, si) => (
                  <i key={si} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>

              {/* Large quote mark */}
              <div className="font-serif text-5xl text-rust-200 leading-none mb-2 select-none">&ldquo;</div>

              {/* Quote */}
              <blockquote className="font-serif text-base md:text-lg text-charcoal italic leading-relaxed mb-6 flex-1">
                {t.text}
              </blockquote>

              {/* Author */}
              <div className="flex items-center justify-between pt-5 border-t border-stone-100">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-rust-700/10 flex-shrink-0">
                    <i className="ri-user-fill text-rust-600 text-base"></i>
                  </div>
                  <div>
                    <p className="font-sans text-sm font-bold text-charcoal leading-none mb-0.5">{t.name}</p>
                    <p className="font-sans text-xs text-stone-400">{t.location}</p>
                  </div>
                </div>
                <div className="flex items-center gap-1.5 text-stone-400">
                  <i className="ri-google-fill text-sm"></i>
                  <span className="font-sans text-[10px] text-stone-400">Google</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Post-testimonial CTA */}
        <div className={`text-center reveal ${inView ? "visible" : ""} reveal-delay-4`}>
          <p className="font-sans text-sm text-stone-500 mb-5">
            Ready to experience the Upper Canada Landscape difference?
          </p>
          <Link
            to="/#contact"
            onClick={() => {
              setTimeout(() => {
                document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
              }, 100);
            }}
            className="whitespace-nowrap inline-flex items-center gap-2 bg-rust-700 hover:bg-rust-800 text-white font-sans text-sm font-semibold px-8 py-3.5 rounded-sm transition-colors cursor-pointer"
          >
            Start Your Consultation
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
